import React from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { IconAlertTriangle, IconArrowsExchange, IconDoorOff } from '@tabler/icons-react';

interface CloseRoomConfirmationModalProps {
    show: boolean;
    roomNumber: string;
    isSubmitting: boolean;
    onClose: () => void;
    onConfirm: (reassignBookings: boolean) => void;
}

const CloseRoomConfirmationModal: React.FC<CloseRoomConfirmationModalProps> = ({ show, roomNumber, isSubmitting, onClose, onConfirm }) => {
    return (
        <Modal show={show} onHide={onClose} centered backdrop={isSubmitting ? 'static' : true}>
            <Modal.Header closeButton={!isSubmitting}>
                <Modal.Title>Close Room {roomNumber}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="d-flex align-items-start">
                    <IconAlertTriangle size={24} className="text-warning me-2 flex-shrink-0" />
                    <p className="mb-0">
                        Room {roomNumber} will be closed. If there are upcoming reservations (not yet checked in) assigned to this room,
                        do you want to automatically move them to another available room of the same room type?
                        If no room is available, the reservation will be unassigned instead.
                    </p>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose} disabled={isSubmitting}>
                    Cancel
                </Button>
                <Button variant="outline-danger" onClick={() => onConfirm(false)} disabled={isSubmitting}>
                    <IconDoorOff size={16} className="me-1" />
                    Close only
                </Button>
                <Button variant="danger" onClick={() => onConfirm(true)} disabled={isSubmitting}>
                    {isSubmitting ? (
                        <>
                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                            <span className="ms-1">Closing...</span>
                        </>
                    ) : (
                        <>
                            <IconArrowsExchange size={16} className="me-1" />
                            Close &amp; move reservations
                        </>
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CloseRoomConfirmationModal;
